import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  previousLocation: sessionStorage.getItem("previous_location") || "",
};

const locationSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setPrevLocation: (state, action: PayloadAction<any>) => {
      state.previousLocation = action.payload;
      sessionStorage.setItem("previous_location", action.payload);
    },
  },
});

export const { setPrevLocation } = locationSlice.actions;

export default locationSlice.reducer;
